import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { WalletProvider } from "./context/WalletContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BottomNav from "./components/BottomNav";
import WalletModal from "./components/WalletModal";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Features from "./pages/Features";
import WalletPage from "./pages/WalletPage";
import Roadmap from "./pages/Roadmap";

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/features" element={<Features />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/roadmap" element={<Roadmap />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <WalletProvider>
      <div className="App animated-gradient min-h-screen pb-16 lg:pb-0">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <AnimatedRoutes />
          <Footer />
          <BottomNav />
          <WalletModal />
        </BrowserRouter>
      </div>
    </WalletProvider>
  );
}

export default App;
